import { time, transformers } from "../utils"

export default {
    data() {
        return {
            headers: [
                { text: "Cart ID", value: "CartName", sortable: false },
                { text: "Contract", value: "ContractName", sortable: true },
                { text: "Status", value: "StateName", sortable: true },
                { text: "Car #", value: "Car", sortable: true },
                {
                    text: "Missing Parts", value: "MissingPartsFormatted", sortable: false, format: {
                        value: "MissingParts", formatter: transformers.missingParts
                    }
                },
                { text: "Station", value: "StationName", sortable: true },
                { text: "Location", value: "LocationName", sortable: true },
                { text: "User", value: "UserName", sortable: true },
                { text: "Notes", value: "Notes", sortable: false },
                {
                    text: "Timestamp", value: "TimestampFormatted", cusOrderByName: "Timestamp", sortable: true, format: {
                        value: "Timestamp", formatter: v => {
                            return time.toTimestampFormat2(v)
                        }
                    }
                }
            ],
        }
    },
}